import React, {FC} from "react";

import Auth from "../components/Auth";

const AuthPage: FC = () => <Auth />;

export default AuthPage;
